import { RootStore, PagedList } from ".";
import { action, runInAction } from "mobx";
import { formatDateJson } from "../common/Formatting";
import { fetchWrapper } from "../common/Fetch";



export interface SearchRequest {
    managerName: string;
    managerId: string;
    date: Date;
    brand: string;
    article: string;
    brandGroupId: number;
    articleId: number;
}

export class SearchHistoryStore {

    _rootStore: RootStore;


    constructor(rootStore: RootStore) {
        this._rootStore = rootStore;
    }

    @action
    loadSearchHistory(managerIds: string[], page = 1, source?: string, dateFrom?: Date, dateTo?: Date, callback?: (positions: SearchRequest[], page: number, totalCount: number) => void) {
        const managerIdsParam = managerIds.length <= 0 ? "" : "&managerIds=" + managerIds.join("&managerIds=");
        const dateFromStr = dateFrom == undefined ? '' : formatDateJson(dateFrom);
        const dateToStr = dateTo == undefined ? '' : formatDateJson(dateTo);
        source = source || "";


        fetchWrapper(`api/SearchHistory/list/${page}?${managerIdsParam}&source=${source}&dateFrom=${dateFromStr}&dateTo=${dateToStr}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }, this._rootStore.commonStore)
            .then(res => res.json() as Promise<PagedList<SearchRequest>>)
            .then(result => {
                runInAction("fetch complete loadSearchHistory", () => {
                    if (result != undefined && callback != undefined) {
                        callback(result.items, result.pageNumber, result.totalItemCount);
                    }

                });
            })
            .catch(res => {
                console.log(res);
            });
    }
}